import type { Order } from '@src/orders/domain/Order';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useQuery } from '@tanstack/react-query';

export const GET_ORDER_QUERY_KEY = ['order.get'];

export const useOrder = ({ id }: { id: string }) => {
  const { data: order, isLoading } = useQuery<Order>({
    queryKey: [...GET_ORDER_QUERY_KEY, id],
    queryFn: () => OrdersClient.find(id),
  });

  return {
    isLoading,
    order,
  };
};
